import { HTTP } from '@/API/base/client'

/**
 * Fetches details for a single event
 * @param  {String} event_id               UUID identifier for an event
 * @return {Response}                   200 response
 */
export const getEventDetails = (event_id) => {
  return HTTP.get(`/careers/events/${event_id}`)
}

/**
 * Fetches list of events based on params
 * @param  {Object} params              Object with params to filter events by
 * @return {Response}                   200 response
 */
export const getEventsList = (params) => {
  return HTTP.get('/careers/events', {
    params,
  })
}

/**
 * Posts to event API to RSVP a student to an event
 * @param  {String} event_id               UUID identifier for an event
 * @param  {Boolean} is_attending          true if the student is RSVPing and false if un-rsvping
 * @return {Response}                   200 response
 */
export const rsvpStudentToEvent = (event_id, is_attending) => {
  return HTTP.post(`/careers/events/${event_id}/rsvp`, {
    is_attending,
  })
}

/**
 * Posts to event API to mark student as an attendee of an event
 * @param  {String} event_id            UUID identifier for an event
 * @return {Response}                   204 response
 */
export const markEventAttendee = (event_id) => {
  return HTTP.post(`/careers/events/${event_id}/mark-attended`)
}
